const injectStyles = () => {
  const shadowHost = document.querySelector('recharge-subscription-widget');
  
  if (shadowHost && shadowHost.shadowRoot) {
    const root = shadowHost.shadowRoot.querySelector('.rc-selection__root');
    const subscriptionDiscount = shadowHost.shadowRoot.querySelector('[part="rc-purchase-option__selector rc-purchase-option__selector_subscription"]')
    console.log("root", root);
    
    if (root) {
        try {
        const newEl = document.createElement('div');
        newEl.className = 'seprater';
        newEl.style.margin = '0 12px';
        newEl.style.border = '1px solid var(--rc-widget-brand-color-50)'
        
        root.insertBefore(newEl, root.children[1]);
        console.log("New element inserted successfully");
        } catch (error) {
        console.error("Error inserting element:", error);
        }
    } else {
        console.log("Root element not found - waiting for it...");
        waitForRootElement(shadowHost);
    }

    try {
        // Create a new CSSStyleSheet
        const customSheet = new CSSStyleSheet();
        customSheet.replaceSync(`
            .rc-purchase-option__subscription:before {
                border-bottom: 1px solid var(--rc-widget-brand-color-50);
            }
        `);
        shadowHost.shadowRoot.adoptedStyleSheets = [
          ...shadowHost.shadowRoot.adoptedStyleSheets,
          customSheet
        ];
      } catch (error) {
        console.error("Error adopting stylesheet:", error);
      }

    const childSecond = shadowHost.shadowRoot.querySelector('rc-selling-plans');
    if (childSecond && childSecond.shadowRoot) {
      try {
        // Create a new CSSStyleSheet
        const customSheet = new CSSStyleSheet();
        customSheet.replaceSync(`
          .rc-plans-dropdown > :nth-child(2) {
            display: flex !important;
            width: 100% !important;
          }
        `);
        childSecond.shadowRoot.adoptedStyleSheets = [
          ...childSecond.shadowRoot.adoptedStyleSheets,
          customSheet
        ];
      } catch (error) {
        console.error("Error adopting stylesheet:", error);
      }
    } 
  }
};

// Wait for both shadow roots to be ready
const waitForShadowHost = () => {
  const shadowHost = document.querySelector('recharge-subscription-widget');
  
  if (shadowHost && shadowHost.shadowRoot) {
    const childSecond = shadowHost.shadowRoot.querySelector('rc-selling-plans');
    
    if (childSecond && childSecond.shadowRoot) {
      // Both shadow roots are ready
      injectStyles();
    } else if (childSecond) {
      // First shadow root ready, waiting for nested shadow root
      const observer = new MutationObserver(() => {
        if (childSecond.shadowRoot) {
          observer.disconnect();
          injectStyles();
        }
      });
      observer.observe(childSecond, { childList: true, subtree: true });
    } else {
      // First shadow root ready, but rc-selling-plans not found yet
      const observer = new MutationObserver(() => {
        const childSecond = shadowHost.shadowRoot.querySelector('rc-selling-plans');
        if (childSecond) {
          observer.disconnect();
          waitForShadowHost(); // Retry to check for nested shadow root
        }
      });
      observer.observe(shadowHost.shadowRoot, { childList: true, subtree: true });
    }
  } else if (shadowHost) {
    // Shadow root not ready yet
    const observer = new MutationObserver(() => {
      if (shadowHost.shadowRoot) {
        observer.disconnect();
        waitForShadowHost();
      }
    });
    observer.observe(shadowHost, { childList: true, subtree: true });
  } else {
    // Element doesn't exist yet
    setTimeout(waitForShadowHost, 100);
  }
};

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForShadowHost);
} else {
  waitForShadowHost();
}
